import { call, CallEffect } from "redux-saga/effects";
import {
  AkaConsent,
  ConsentDto,
  CustomerMasterConsents,
} from "./consentInterfaces";

import { AxiosResponse } from "axios";
import { createRequest } from "Utils/requestUtils";

const categoryMembership = "membership";
const subCategoryUnion = "union";

export function* postMarketingConsentForCustomer(
  consented: boolean,
  purpose: string,
  nin: string,
): Generator<CallEffect<AxiosResponse<any>>, void> {
  const dto: ConsentDto = {
    category: "purchase_assistance",
    collectionMethod: "WEB",
    consent: consented,
    consentDurationType: "FIXED_NUMBER_OF_DAYS",
    consentType: "EXPLICIT",
    customerNin: nin,
    lineOfBusiness: "STB",
    numberOfDaysValid: 30,
    purpose,
    purposeCategory: "MARKETING",
    source: "buy-insurance-web",
    subCategory: "sjekk-pris",
  };
  yield call(createRequest, {
    method: "post",
    requestBody: dto,
    url: "/open/consents",
  });
}

export function* postAkaConsentForCustomer(
  consent: AkaConsent,
): Generator<CallEffect<AxiosResponse<any>>, void> {
  const dto: CustomerMasterConsents = {
    useUnionMembership: consent.consented,
  };
  yield call(createRequest, {
    method: "patch",
    requestBody: dto,
    url: "/customer/core-data.v3",
    open: false,
  });
}

export const getAllConsentsForCustomer = (): CallEffect<AxiosResponse<any>> =>
  call(createRequest, {
    method: "get",
    url: "/me/consents",
    open: false,
  });

export const getAkaConsentForCustomer = (): CallEffect<AxiosResponse<any>> =>
  call(createRequest, {
    method: "get",
    url: `/me/consents/category/${categoryMembership}/subcategory/${subCategoryUnion}`,
    open: false,
  });
